export default "__VITE_ASSET__F46ELhFc__"